module.exports = __webpack_public_path__ + "media/img/frontend_application/profile_completed_icon-5511c22684570688d0e09553759cd94b.svg";